<template>
  <v-dialog :value="value" @input="$emit('input', $event)" width="820" scrollable>
    <v-card v-if="arrivo && settimana">
      <!-- Titolo -->
      <v-card-title class="grey--text text-subtitle-1">
        <v-avatar size="32" class="mr-2">
          <v-img :src="avatarFornitore(arrivo.id_fornitore)" />
        </v-avatar>
        {{ nomeFornitore(arrivo.id_fornitore) }}
        <span class="font-weight-light ml-2 text-body-2">
          Settimana #{{ settimana.numero + 1 }}
        </span>
        <v-spacer />
        <v-btn icon small @click="on_edit = !on_edit" class="mr-1">
          <v-icon small>{{ on_edit ? 'mdi-pencil-off' : 'mdi-pencil' }}</v-icon>
        </v-btn>
        <v-btn icon small @click="$emit('input', false)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text class="pa-4" style="max-height: 70vh;">
        <!-- PDF -->
        <v-row v-if="on_edit" class="mb-2">
          <v-col>
            <v-file-input
              v-model="file_pdf"
              outlined dense
              accept="application/pdf"
              placeholder="Carica PDF bolla"
              prepend-inner-icon="mdi-file-pdf-box"
              label="PDF bolla"
              hide-details
              :loading="loading_pdf"
            />
          </v-col>
        </v-row>
        <v-list-item v-if="arrivo_live && arrivo_live.pdf" dense class="pa-0 mb-3">
          <v-list-item-avatar size="28">
            <v-icon color="red">mdi-file-pdf-box</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-caption">{{ arrivo_live.pdf }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="flex-row" style="gap: 4px;">
            <v-btn icon small @click="scaricaPdf">
              <v-icon small>mdi-download</v-icon>
            </v-btn>
            <v-btn v-if="on_edit" icon small color="red" :loading="loading_delete_pdf" @click="eliminaPdf">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-divider class="mb-3" />

        <!-- Colonne Seme / Talea -->
        <v-row>
          <v-col cols="6">
            <div class="d-flex align-center mb-2 text-caption font-weight-bold grey--text text--darken-1">
              <v-icon x-small class="mr-1">mdi-seed</v-icon> Seme
            </div>
            <div v-if="!prodotti_seme.length" class="text-caption grey--text">Nessuno</div>
            <v-list dense class="pa-0">
              <v-list-item
                v-for="prodotto in prodotti_seme"
                :key="prodotto.id"
                dense class="pa-0"
                style="min-height: 36px;"
              >
                <v-list-item-avatar size="26" class="mr-2 my-0">
                  <v-img :src="avatarSpecie(prodotto.id_specie)" />
                </v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <v-list-item-title class="text-caption">
                    {{ nomeSpecie(prodotto.id_specie) }}
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="prodotto.id_stagione" class="grey--text font-italic" style="font-size: 10px;">
                    {{ nomeStagione(prodotto.id_stagione) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action-text>
                  <span class="text-body-2 font-weight-medium">{{ prodotto.qta }}</span>
                </v-list-item-action-text>
                <v-list-item-action v-if="on_edit" class="my-0 ml-1 d-flex flex-row align-center" style="gap: 2px;">
                  <v-btn icon x-small color="blue" @click="apriEditProdotto(prodotto)">
                    <v-icon x-small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon x-small color="red"
                         :loading="deletingProdottoId === prodotto.id"
                         @click="eliminaProdotto(prodotto)">
                    <v-icon x-small>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>

          <v-divider vertical />

          <v-col cols="6">
            <div class="d-flex align-center mb-2 text-caption font-weight-bold grey--text text--darken-1">
              <v-icon x-small class="mr-1">mdi-sprout</v-icon> Talea
            </div>
            <div v-if="!prodotti_talea.length" class="text-caption grey--text">Nessuna</div>
            <v-list dense class="pa-0">
              <v-list-item
                v-for="prodotto in prodotti_talea"
                :key="prodotto.id"
                dense class="pa-0"
                style="min-height: 36px;"
              >
                <v-list-item-avatar size="26" class="mr-2 my-0">
                  <v-img :src="avatarSpecie(prodotto.id_specie)" />
                </v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <v-list-item-title class="text-caption">
                    {{ nomeSpecie(prodotto.id_specie) }}
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="prodotto.id_stagione" class="grey--text font-italic" style="font-size: 10px;">
                    {{ nomeStagione(prodotto.id_stagione) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action-text>
                  <span class="text-body-2 font-weight-medium">{{ prodotto.qta }}</span>
                </v-list-item-action-text>
                <v-list-item-action v-if="on_edit" class="my-0 ml-1 d-flex flex-row align-center" style="gap: 2px;">
                  <v-btn icon x-small color="blue" @click="apriEditProdotto(prodotto)">
                    <v-icon x-small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon x-small color="red"
                         :loading="deletingProdottoId === prodotto.id"
                         @click="eliminaProdotto(prodotto)">
                    <v-icon x-small>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>

        <!-- Aggiungi prodotto in edit mode -->
        <template v-if="on_edit">
          <v-divider class="my-3" />
          <v-row dense class="mb-3">
            <v-col cols="12" sm="6">
              <v-select
                v-model="id_stagione_sel"
                :items="stagioni_items"
                label="Stagione"
                outlined dense hide-details
                prepend-inner-icon="mdi-calendar-range"
                clearable
              />
            </v-col>
          </v-row>
          <v-row align="center" dense>
            <v-col cols="6">
              <v-autocomplete
                v-model="nuovo_id_specie"
                :items="specie_disponibili"
                item-text="nome"
                item-value="id"
                label="Aggiungi specie"
                outlined dense hide-details
                prepend-inner-icon="mdi-spa"
                ref="autocomplete_specie"
              >
                <template #item="{ item }">
                  <v-list-item-avatar size="24">
                    <v-img :src="avatarSpecie(item.id)" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">{{ item.nome }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model.number="nuova_qta"
                outlined dense hide-details
                type="number" min="1" label="Qta"
                :disabled="!nuovo_id_specie"
                ref="campo_qta"
                @keyup.enter="aggiungiProdotto"
              />
            </v-col>
            <v-col cols="2">
              <v-combobox
                v-model="nuova_qta_per_cassa"
                :items="qta_per_cassa_suggerite"
                label="x cassa"
                outlined dense hide-details
                type="number"
              />
            </v-col>
            <v-col cols="1" class="text-caption grey--text text-center">
              = {{ nuova_qta_to_reg }}
            </v-col>
            <v-col cols="1" class="d-flex justify-center">
              <v-btn icon color="green"
                     :disabled="!nuovo_id_specie || nuova_qta_to_reg < 1"
                     :loading="loading_add_prodotto"
                     @click="aggiungiProdotto">
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>

        <v-alert v-if="errore" type="error" outlined dense class="mt-3">{{ errore }}</v-alert>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <!-- Elimina arrivo (solo edit mode) -->
        <v-dialog v-if="on_edit" v-model="dialog_elimina_arrivo" width="300">
          <template #activator="{ on }">
            <v-btn outlined color="red" small v-on="on">
              <v-icon small class="mr-1">mdi-delete</v-icon>Elimina arrivo
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="red--text text-subtitle-1">Conferma eliminazione</v-card-title>
            <v-card-text>Eliminare l'arrivo di {{ nomeFornitore(arrivo.id_fornitore) }}?</v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text color="grey" @click="dialog_elimina_arrivo = false">Annulla</v-btn>
              <v-btn outlined color="red" :loading="loading_elimina_arrivo" @click="eliminaArrivo">
                <v-icon small class="mr-1">mdi-delete</v-icon>Elimina
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-spacer />
        <v-btn text color="grey" @click="$emit('input', false)">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
    <!-- Dialog modifica singolo prodotto -->
    <v-dialog v-model="dialog_edit_prodotto" max-width="300" persistent>
      <v-card v-if="prodotto_edit.id">
        <v-card-title class="text-subtitle-2 grey--text">Modifica prodotto</v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <v-text-field
            v-model.number="prodotto_edit.qta"
            outlined dense
            type="number" min="1"
            label="Quantità"
            class="mb-3"
          />
          <v-select
            v-model="prodotto_edit.id_stagione"
            :items="stagioni_items"
            label="Stagione"
            outlined dense
            clearable
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey" @click="dialog_edit_prodotto = false">Annulla</v-btn>
          <v-btn text color="primary" :loading="loading_edit_prodotto" @click="salvaEditProdotto">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import axios from "axios";
export default {
  name: "DettaglioArrivoDialog",
  props: {
    value:             { type: Boolean, default: false },
    arrivo:            { type: Object, default: null },
    settimana:         { type: Object, default: null },
    anno:              { type: [Number, String], required: true },
    specie_disponibili: { type: Array, default: () => [] },
    fornitori:         { type: Array, default: () => [] },
    stagione_attiva:   { type: Object, default: null },
  },
  data() {
    return {
      on_edit: false,
      file_pdf: null,
      loading_pdf: false,
      loading_delete_pdf: false,
      loading_add_prodotto: false,
      deletingProdottoId: null,
      loading_elimina_arrivo: false,
      dialog_edit_prodotto: false,
      prodotto_edit: { id: null, qta: 1, id_stagione: null },
      loading_edit_prodotto: false,
      dialog_elimina_arrivo: false,
      nuovo_id_specie: null,
      nuova_qta: 1,
      nuova_qta_per_cassa: null,
      qta_per_cassa_suggerite: [],
      errore: "",
      id_stagione_sel: null,
    };
  },
  created() {
    const stored = localStorage.getItem("qta_per_cassa_suggerite");
    if (stored) {
      try { this.qta_per_cassa_suggerite = JSON.parse(stored); }
      catch { this.qta_per_cassa_suggerite = []; }
    }
  },
  watch: {
    value(val) {
      if (!val) {
        this.on_edit = false;
        this.errore = "";
        this.nuovo_id_specie = null;
        this.nuova_qta = 1;
        this.nuova_qta_per_cassa = null;
        this.id_stagione_sel = this.stagione_attiva?.id ?? null;
      }
    },
    stagione_attiva: {
      immediate: true,
      handler(val) { this.id_stagione_sel = val?.id ?? null; },
    },
    file_pdf(file) {
      if (!file) return;
      this.uploadPdf(file);
    },
  },
  computed: {
    nuova_qta_to_reg() {
      const x = Number(this.nuova_qta_per_cassa);
      if (x && !isNaN(x) && x > 0) return this.nuova_qta * x;
      return this.nuova_qta;
    },
    // Legge l'arrivo aggiornato dallo store invece della prop statica.
    // Necessario perché le mutazioni creano nuovi oggetti (spread immutabile)
    // rompendo il riferimento della prop passata al momento dell'apertura.
    arrivo_live() {
      if (!this.arrivo || !this.settimana) return this.arrivo;
      const cal = this.$store.getters.get_calendario_arrivi(this.anno);
      if (!cal) return this.arrivo;
      const sett = cal.settimane.find((s) => s.id == this.settimana.id);
      if (!sett) return this.arrivo;
      return sett.arrivi.find((a) => a.id == this.arrivo.id) || this.arrivo;
    },
    prodotti_seme() {
      if (!this.arrivo_live?.prodotti) return [];
      return this.arrivo_live.prodotti.filter((p) => {
        const sp = this.specie_disponibili.find((s) => s.id == p.id_specie);
        return sp?.propagazione == 1;
      });
    },
    prodotti_talea() {
      if (!this.arrivo_live?.prodotti) return [];
      return this.arrivo_live.prodotti.filter((p) => {
        const sp = this.specie_disponibili.find((s) => s.id == p.id_specie);
        return sp?.propagazione == 2;
      });
    },
    stagioni_items() {
      const stagioni = this.$store.getters.getStagioniColtivazione || [];
      return stagioni.map((s) => ({
        value: s.id,
        text: `${s.tipo_stagione?.nome || "Stagione"} ${s.anno}`,
      }));
    },
  },
  methods: {
    avatarFornitore(id) {
      return process.env.VUE_APP_API_ROOT + "/fornitore/" + id + "/avatar";
    },
    avatarSpecie(id) {
      return process.env.VUE_APP_API_ROOT + "/specie/" + id + "/img";
    },
    nomeFornitore(id) {
      return this.fornitori.find((f) => f.id == id)?.nome || "Fornitore #" + id;
    },
    nomeSpecie(id) {
      return this.specie_disponibili.find((s) => s.id == id)?.nome || "Specie #" + id;
    },
    nomeStagione(id_stagione) {
      const stagioni = this.$store.getters.getStagioniColtivazione || [];
      const s = stagioni.find((s) => s.id == id_stagione);
      return s ? `${s.tipo_stagione?.nome || "Stagione"} ${s.anno}` : null;
    },
    async aggiungiProdotto() {
      if (!this.nuovo_id_specie || this.nuova_qta_to_reg < 1) return;
      this.loading_add_prodotto = true;
      this.errore = "";
      try {
        await this.$store.dispatch("aggiungi_prodotto_arrivo", {
          anno:         this.anno,
          id_settimana: this.settimana.id,
          id_arrivo:    this.arrivo.id,
          id_specie:    this.nuovo_id_specie,
          qta:          this.nuova_qta_to_reg,
          id_stagione:  this.id_stagione_sel,
        });
        // Aggiorna suggerimenti qta_per_cassa
        const x = Number(this.nuova_qta_per_cassa);
        if (x && !isNaN(x) && !this.qta_per_cassa_suggerite.includes(x)) {
          this.qta_per_cassa_suggerite.push(x);
          this.qta_per_cassa_suggerite.sort((a, b) => a - b);
          localStorage.setItem(
            "qta_per_cassa_suggerite",
            JSON.stringify(this.qta_per_cassa_suggerite)
          );
        }
        this.nuovo_id_specie = null;
        this.nuova_qta = 1;
        this.$nextTick(() => {
          this.$refs.autocomplete_specie?.focus();
        });
      } catch {
        this.errore = "Errore durante l'aggiunta del prodotto.";
      } finally {
        this.loading_add_prodotto = false;
      }
    },
    apriEditProdotto(prodotto) {
      this.prodotto_edit = {
        id:          prodotto.id,
        qta:         prodotto.qta,
        id_stagione: prodotto.id_stagione ?? null,
      };
      this.dialog_edit_prodotto = true;
    },
    async salvaEditProdotto() {
      if (!this.prodotto_edit.qta || this.prodotto_edit.qta < 1) return;
      this.loading_edit_prodotto = true;
      this.errore = "";
      try {
        await this.$store.dispatch("modifica_prodotto_arrivo", {
          anno:         this.anno,
          id_settimana: this.settimana.id,
          id_arrivo:    this.arrivo.id,
          id_prodotto:  this.prodotto_edit.id,
          qta:          this.prodotto_edit.qta,
          id_stagione:  this.prodotto_edit.id_stagione,
        });
        this.dialog_edit_prodotto = false;
      } catch {
        this.errore = "Errore durante la modifica del prodotto.";
      } finally {
        this.loading_edit_prodotto = false;
      }
    },
    async eliminaProdotto(prodotto) {
      this.deletingProdottoId = prodotto.id;
      this.errore = "";
      try {
        await this.$store.dispatch("rimuovi_prodotto_arrivo", {
          anno:         this.anno,
          id_settimana: this.settimana.id,
          id_arrivo:    this.arrivo.id,
          id_prodotto:  prodotto.id,
        });
      } catch {
        this.errore = "Errore durante l'eliminazione.";
      } finally {
        this.deletingProdottoId = null;
      }
    },
    async eliminaArrivo() {
      this.loading_elimina_arrivo = true;
      try {
        await this.$store.dispatch("rimuovi_arrivo_settimana", {
          anno:         this.anno,
          id_settimana: this.settimana.id,
          id_arrivo:    this.arrivo.id,
        });
        this.dialog_elimina_arrivo = false;
        this.$emit("input", false);
      } catch {
        this.errore = "Errore durante l'eliminazione dell'arrivo.";
      } finally {
        this.loading_elimina_arrivo = false;
      }
    },
    async uploadPdf(file) {
      this.loading_pdf = true;
      const formData = new FormData();
      formData.append("file", file);
      const url =
        process.env.VUE_APP_API_ROOT +
        "/admin/calendario_arrivi/arrivo/" +
        this.arrivo.id +
        "/pdf";
      const auth = this.$store.getters.get_credential;
      try {
        await axios.post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          auth,
        });
        this.$store.commit("set_nome_pdf_arrivo", {
          anno:         this.anno,
          id_settimana: this.settimana.id,
          id_arrivo:    this.arrivo.id,
          file_name:    file.name,
        });
        this.file_pdf = null;
      } catch {
        this.errore = "Errore durante l'upload del PDF.";
      } finally {
        this.loading_pdf = false;
      }
    },
    async eliminaPdf() {
      this.loading_delete_pdf = true;
      try {
        await this.$store.dispatch("elimina_pdf_arrivo", {
          anno:         this.anno,
          id_settimana: this.settimana.id,
          id_arrivo:    this.arrivo.id,
        });
      } catch {
        this.errore = "Errore durante l'eliminazione del PDF.";
      } finally {
        this.loading_delete_pdf = false;
      }
    },
    scaricaPdf() {
      const url =
        process.env.VUE_APP_API_ROOT +
        "/admin/calendario_arrivi/arrivo/" +
        this.arrivo.id +
        "/pdf";
      window.open(url, "_blank");
    },
  },
};
</script>
